import { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Plus, X, Tags } from "lucide-react";

export function CategorieManager({ open, onOpenChange, onChange }) {
  const [cats, setCats] = useState([]);
  const [nuova, setNuova] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/categorie").then((r) => setCats(r.data.categorie || [])).catch(() => {});
  useEffect(() => { if (open) { load(); setNuova(""); } }, [open]);

  const apply = (lista) => { setCats(lista); onChange && onChange(lista); };

  const aggiungi = async () => {
    const nome = nuova.trim();
    if (!nome) return;
    setBusy(true);
    try {
      const { data } = await api.post("/categorie", { nome });
      apply(data.categorie); setNuova("");
      toast.success(`Categoria "${nome}" aggiunta`);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Errore"); }
    setBusy(false);
  };

  const rimuovi = async (nome) => {
    if (!window.confirm(`Rimuovere la categoria "${nome}"?\n\nLe manutenzioni e i fornitori già associati conservano il valore, ma non sarà più selezionabile.`)) return;
    try {
      const { data } = await api.delete(`/categorie/${encodeURIComponent(nome)}`);
      apply(data.categorie);
      toast.success(`Categoria "${nome}" rimossa`);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Errore"); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="categorie-manager">
        <DialogHeader>
          <DialogTitle className="text-xl flex items-center gap-2"><Tags className="w-5 h-5 text-brand" /> Gestisci categorie</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-500">Le categorie sono condivise tra Manutenzioni e Account Fornitori.</p>
        <div className="flex gap-2">
          <Input data-testid="categoria-nuova-input" value={nuova} onChange={(e) => setNuova(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && aggiungi()} placeholder="Nuova categoria (es. Antincendio)" className="h-11" />
          <Button data-testid="categoria-aggiungi-btn" disabled={busy || !nuova.trim()} onClick={aggiungi}
            className="h-11 bg-brand hover:bg-brand-dark font-bold shrink-0">
            <Plus className="w-4 h-4 mr-1" /> Aggiungi
          </Button>
        </div>
        <div className="flex flex-wrap gap-2 max-h-72 overflow-y-auto pt-1" data-testid="categorie-lista">
          {cats.map((c) => (
            <span key={c} data-testid={`categoria-chip-${c}`}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border-2 border-slate-200 text-sm font-semibold text-slate-700">
              {c}
              {c !== "Altro" && (
                <button type="button" data-testid={`categoria-rimuovi-${c}`} onClick={() => rimuovi(c)}
                  className="text-slate-400 hover:text-red-600" title="Rimuovi">
                  <X className="w-4 h-4" />
                </button>
              )}
            </span>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
